import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { MapPin, Loader2 } from "lucide-react";
import { toast } from "sonner";

export const SherlockCorrectionSettings = () => {
  const [cfg, setCfg] = useState({ stationary_minutes: 30, distance_m: 20 });
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.sherlockCfgGet().then(setCfg).catch(() => {}); }, []);

  const save = async () => {
    const m = Number(cfg.stationary_minutes), d = Number(cfg.distance_m);
    if (!(m >= 10) || !(d >= 10)) { toast.error("Minimum 10 untuk kedua nilai"); return; }
    setBusy(true);
    try {
      setCfg(await api.sherlockCfgSave({ stationary_minutes: m, distance_m: d }));
      toast.success("Pengaturan Re-Correction Sherlock disimpan");
    } catch (e) {
      toast.error(e?.response?.data?.detail?.[0]?.msg || "Gagal menyimpan");
    } finally { setBusy(false); }
  };

  return (
    <div className="border border-border rounded-sm bg-white p-5" data-testid="sherlock-correction-section">
      <div className="flex items-center gap-2 mb-1 flex-wrap">
        <MapPin className="w-5 h-5 text-emerald-700" />
        <h2 className="text-base font-bold tracking-tight">Re-Correction Sherlock</h2>
      </div>
      <p className="text-[11px] text-zinc-500 mb-3">
        Saat WO selesai (DONE), koordinat lokasi customer dikoreksi otomatis dari GPS armada
        bila armada diam selama periode ini dan posisinya berbeda melebihi jarak koreksi.
      </p>
      <div className="flex flex-wrap items-end gap-3">
        <label className="text-[11px] text-zinc-600">
          Threshold diam (menit)
          <Input type="number" min={10} value={cfg.stationary_minutes}
            onChange={e => setCfg({ ...cfg, stationary_minutes: e.target.value })}
            className="h-9 w-32 mt-1" data-testid="sherlock-stationary-minutes" />
        </label>
        <label className="text-[11px] text-zinc-600">
          Threshold koreksi jarak (meter)
          <Input type="number" min={10} value={cfg.distance_m}
            onChange={e => setCfg({ ...cfg, distance_m: e.target.value })}
            className="h-9 w-32 mt-1" data-testid="sherlock-distance-m" />
        </label>
        <Button onClick={save} disabled={busy} className="h-9" data-testid="sherlock-save-btn">
          {busy && <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" />}Simpan
        </Button>
      </div>
    </div>
  );
};
